var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'popup',
    ("popup__valign-" + _vm.popUpValign),
    {'popup__top': _vm.top0}
  ]},[_c('VueCustomScrollbar',{staticClass:"scroll-area"},[_c(_vm.popUpComponent,_vm._b({tag:"Component",staticClass:"popup_content"},'Component',Object.assign({}, _vm.popUpProps),false))],1),(_vm.popUpCanClose)?_c('button',{staticClass:"dialog_close",on:{"click":function($event){return _vm.$emit('closePopUp')}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }